<template>
  <div class="detail-page-layout">
    <el-breadcrumb separator="/" class="breadcrumb">
      <template v-for="breadcrumb in config.Breadcrumbs">
        <el-breadcrumb-item :key="breadcrumb.name" v-if="breadcrumb.to" :to="breadcrumb.to">{{breadcrumb.name}}</el-breadcrumb-item>
        <el-breadcrumb-item :key="breadcrumb.name" v-else>{{breadcrumb.name}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <StepsBar v-if="config.StepsBarEnabled" :steps="config.Steps" :step="config.Step"></StepsBar>
    <v-card>
      <slot></slot>
    </v-card>
  </div>
</template>

<script>
import StepsBar from './StepsBar'
import vCard from './Card'
export default {
  props: {
    config: Object,
  },
  components: {
    StepsBar,
    vCard,
  },
}
</script>

<style lang="less">
.detail-page-layout {
  .breadcrumb.el-breadcrumb {
    font-size: 26px;
    margin: 30px 0;
  }
  .el-breadcrumb__item__inner, .el-breadcrumb__item__inner a {
    color: #20a0ff;
    font-size: 26px;
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__item__inner, .el-breadcrumb__item:last-child .el-breadcrumb__item__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__item__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__item__inner:hover {
    color: #a6afb7;
    font-size: 18px;
    line-height: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// DetailPageLayout.vue?142d32f0